import { Typo3Integrations } from '@/types'
import { create } from 'zustand'
import createSelectors from '../utils/createSelectors'

interface State {
  integrations: Typo3Integrations | null
}
interface Action {
  setIntegrations: (integrations: State['integrations']) => void
  reset: () => void
}

const baseStoreIntegrations = create<State & Action>((set) => ({
  integrations: null,
  setIntegrations: (integrations) => set(() => ({ integrations })),
  reset: () =>
    set({
      integrations: null
    })
}))

const useStoreIntegrations = createSelectors(baseStoreIntegrations)

export default useStoreIntegrations
